export default "__VITE_ASSET__DfbDwOyz__"